/**
 * @description Model of Agent
 */
export class Agent {
  id?: string;
  firstName: string;
  lastName: string;
  image: string;
  name: string;
  phone: string;
  mobileNumber: string;
  state?: string;
  address?: string;
  email: string;
  welcomePopup: string;

  constructor(dataObject?) {
    dataObject = dataObject || {};
    this.id = dataObject.id || '';
    this.email = dataObject.email || '';
    if (dataObject.user_profile) {
      this.name = dataObject.user_profile.name || '';
      this.firstName = dataObject.user_profile.first_name || '';
      this.lastName = dataObject.user_profile.last_name || '';
      this.phone = dataObject.user_profile.phone || '';
      this.mobileNumber = dataObject.user_profile.mobile_number || '';
      this.state = dataObject.user_profile.state || '';
      this.address = dataObject.user_profile.address || '';
      if (dataObject.user_profile.user_profile_meta) {
        for (let meta of dataObject.user_profile.user_profile_meta) {
          let image = meta['profile_image_link'];
          if (image) this.image = image;
          if (meta.hasOwnProperty('google_email'))
            this.email = meta['google_email'];
          if (meta.hasOwnProperty('agent_welcome_popup'))
            this.welcomePopup = meta['agent_welcome_popup'];
        }
      }
    }
  }
}
